import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const fields = this.element.querySelectorAll("input, select, textarea")

    fields.forEach((field) => {
      if (field.value === "" || field.value == null) {
        field.dataset.originalName = field.name
        field.removeAttribute("name")
      }
    })
  }
}
